import React from 'react';
import { render, findDOMNode } from 'react-dom';
import { useSelector } from 'react-redux';

function SearchComponent(props) {
  const currentOrgUnitFilter = useSelector((state) => state.organisationsReducer.currentOrgUnitFilter);
  const handleTypingEnter = (event) => {
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      props.onKeyUpHandler();
    }
  };

  const { onKeyUpHandler, ...rest } = props;
  return <input type="text" onKeyUp={handleTypingEnter} value={currentOrgUnitFilter || ''} {...rest} />;
}

export default SearchComponent;
